export const setStorage = (key, val) => {
  localStorage.setItem(key, val);
};

export const getStorage = (key) => (
  localStorage.getItem(key)
);